import * as metaStateUtils from '../../../store/util/metaStateUtils';


/**
 * @param state {object} Global state
 * @return {object}
 */
export const getDomainState = state => {

    return state.config;
};


/**
 * @param state {object}
 * @return {object}
 */
export const getGeoConfig = state => {

    return getDomainState(state)
        .geo;
};


/**
 * @param state {object}
 * @return {object}
 */
export const getGlobalConfig = state => {

    return getDomainState(state)
        .global;
};


/**
 * @param state {object}
 * @return {array|object[]}
 */
export const getPlatformLanguages = state => {

    return getGlobalConfig(state)
        .platformLanguages;
};


/**
 * @param state {object}
 * @return {array|object[]}
 */
export const getSourceContentLanguages = state => {

    return getGlobalConfig(state)
        .sourceContentLanguages;
};


/**
 * @param state {object}
 * @return {Boolean}
 */
export const isGeoConfigLoaded = state => {

    const geoConfig = getGeoConfig(state);

    return metaStateUtils.isLoaded(geoConfig);
};


/**
 * @param state {object}
 * @return {Boolean}
 */
export const isGeoConfigLoading = state => {

    const geoConfig = getGeoConfig(state);

    return metaStateUtils.isLoading(geoConfig);
};


/**
 * @param state {object}
 * @return {Boolean}
 */
export const isGlobalConfigLoaded = state => {

    const globalConfig = getGlobalConfig(state);

    return metaStateUtils.isLoaded(globalConfig);
};


/**
 * @param state {object}
 * @return {Boolean}
 */
export const isGlobalConfigLoading = state => {

    const globalConfig = getGlobalConfig(state);

    return metaStateUtils.isLoading(globalConfig);
};


/**
 * @param state {object} Global state
 * @return {object[]} Countries
 */
export const getCountries = state => {

    return getGeoConfig(state)
        .countries;
};


/**
 * @param state {object} Global state
 * @param countryAlpha2 {string} Two letter ISO country code
 * @return {object} CountriesCount
 */
export const getCountry = (state, countryAlpha2) => {

    return getCountries(state)
        .find(country => country.alpha2 === countryAlpha2);
};


/**
 * Returns the region hierarchy
 *
 * @param state {object} Global state
 * @return {{}} Region by code -> subRegion by subRegion code -> country by country code
 */
export const getRegionHierarchy = state => {

    const geoConfig = getGeoConfig(state);

    return geoConfig.regionByCode || {};
};



/**
 * @param state {object}
 * @return {object}
 */
export const getUserConfig = state => {

    return getDomainState(state)
        .user;
};


/**
 * @param state {object}
 * @return {Boolean}
 */
export const isUserConfigLoaded = state => {

    const userConfig = getUserConfig(state);

    return metaStateUtils.isLoaded(userConfig);
};


/**
 * @param state {object}
 * @return {Boolean}
 */
export const isUserConfigLoading = state => {

    const userConfig = getUserConfig(state);

    return metaStateUtils.isLoading(userConfig);
};
